import { jsx as d, jsxs as F, Fragment as I } from "react/jsx-runtime";
import { createContext as A, forwardRef as Dt, useContext as q, useState as J, useEffect as ie, useLayoutEffect as Mt, useRef as kt } from "react";
import { $ as fe } from "./utils-CTvPli9r.js";
import { buttonVariants as Fe } from "./button.js";
import { c as Xe } from "./createLucideIcon-Bs_bgX_W.js";
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nt = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], xt = Xe("chevron-left", Nt);
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pt = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], Ct = Xe("chevron-right", Pt), Me = 6048e5, Ot = 864e5, Ee = Symbol.for("constructDateFrom");
function C(e, n) {
  return typeof e == "function" ? e(n) : e && typeof e == "object" && Ee in e ? e[Ee](n) : e instanceof Date ? new e.constructor(n) : new Date(n);
}
function k(e, n) {
  return C(n || e, e);
}
function O(e, n, t) {
  const r = k(e, t == null ? void 0 : t.in);
  return isNaN(n) ? C((t == null ? void 0 : t.in) || e, NaN) : (n && r.setDate(r.getDate() + n), r);
}
function W(e, n, t) {
  const r = k(e, t == null ? void 0 : t.in);
  if (isNaN(n)) return C((t == null ? void 0 : t.in) || e, NaN);
  if (!n)
    return r;
  const a = r.getDate(), o = C((t == null ? void 0 : t.in) || e, r.getTime());
  o.setMonth(r.getMonth() + n + 1, 0);
  const i = o.getDate();
  return a >= i ? o : (r.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    a
  ), r);
}
let pt = {};
function Z() {
  return pt;
}
function E(e, n) {
  var s, u, c, l;
  const t = Z(), r = (n == null ? void 0 : n.weekStartsOn) ?? ((u = (s = n == null ? void 0 : n.locale) == null ? void 0 : s.options) == null ? void 0 : u.weekStartsOn) ?? t.weekStartsOn ?? ((l = (c = t.locale) == null ? void 0 : c.options) == null ? void 0 : l.weekStartsOn) ?? 0, a = k(e, n == null ? void 0 : n.in), o = a.getDay(), i = (o < r ? 7 : 0) + o - r;
  return a.setDate(a.getDate() - i), a.setHours(0, 0, 0, 0), a;
}
function j(e, n) {
  return E(e, { ...n, weekStartsOn: 1 });
}
function Ve(e, n) {
  const t = k(e, n == null ? void 0 : n.in), r = t.getFullYear(), a = C(t, 0);
  a.setFullYear(r + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const o = j(a), i = C(t, 0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  const s = j(i);
  return t.getTime() >= o.getTime() ? r + 1 : t.getTime() >= s.getTime() ? r : r - 1;
}
function ae(e) {
  const n = k(e), t = new Date(
    Date.UTC(
      n.getFullYear(),
      n.getMonth(),
      n.getDate(),
      n.getHours(),
      n.getMinutes(),
      n.getSeconds(),
      n.getMilliseconds()
    )
  );
  return t.setUTCFullYear(n.getFullYear()), +e - +t;
}
function G(e, ...n) {
  const t = C.bind(
    null,
    e || n.find((r) => typeof r == "object")
  );
  return n.map(t);
}
function V(e, n) {
  const t = k(e, n == null ? void 0 : n.in);
  return t.setHours(0, 0, 0, 0), t;
}
function T(e, n, t) {
  const [r, a] = G(
    t == null ? void 0 : t.in,
    e,
    n
  ), o = V(r), i = V(a), s = +o - ae(o), u = +i - ae(i);
  return Math.round((s - u) / Ot);
}
function St(e, n) {
  const t = Ve(e, n), r = C(e, 0);
  return r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0), j(r);
}
function _e(e, n, t) {
  return O(e, n * 7, t);
}
function Wt(e, n, t) {
  return W(e, n * 12, t);
}
function Yt(e, n) {
  let t, r = n == null ? void 0 : n.in;
  return e.forEach((a) => {
    !r && typeof a == "object" && (r = C.bind(null, a));
    const o = k(a, r);
    (!t || t < o || isNaN(+o)) && (t = o);
  }), C(r, t || NaN);
}
function Tt(e, n) {
  let t, r = n == null ? void 0 : n.in;
  return e.forEach((a) => {
    !r && typeof a == "object" && (r = C.bind(null, a));
    const o = k(a, r);
    (!t || t > o || isNaN(+o)) && (t = o);
  }), C(r, t || NaN);
}
function p(e, n, t) {
  const [r, a] = G(
    t == null ? void 0 : t.in,
    e,
    n
  );
  return +V(r) == +V(a);
}
function ke(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Ft(e) {
  return !(!ke(e) && typeof e != "number" || isNaN(+k(e)));
}
function K(e, n, t) {
  const [r, a] = G(
    t == null ? void 0 : t.in,
    e,
    n
  ), o = r.getFullYear() - a.getFullYear(), i = r.getMonth() - a.getMonth();
  return o * 12 + i;
}
function Et(e, n, t) {
  const [r, a] = G(
    t == null ? void 0 : t.in,
    e,
    n
  ), o = E(r, t), i = E(a, t), s = +o - ae(o), u = +i - ae(i);
  return Math.round((s - u) / Me);
}
function Ne(e, n) {
  const t = k(e, n == null ? void 0 : n.in), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function S(e, n) {
  const t = k(e, n == null ? void 0 : n.in);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function Ge(e, n) {
  const t = k(e, n == null ? void 0 : n.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function xe(e, n) {
  var s, u, c, l;
  const t = Z(), r = (n == null ? void 0 : n.weekStartsOn) ?? ((u = (s = n == null ? void 0 : n.locale) == null ? void 0 : s.options) == null ? void 0 : u.weekStartsOn) ?? t.weekStartsOn ?? ((l = (c = t.locale) == null ? void 0 : c.options) == null ? void 0 : l.weekStartsOn) ?? 0, a = k(e, n == null ? void 0 : n.in), o = a.getDay(), i = (o < r ? -7 : 0) + 6 - (o - r);
  return a.setDate(a.getDate() + i), a.setHours(23, 59, 59, 999), a;
}
function $e(e, n) {
  return xe(e, { ...n, weekStartsOn: 1 });
}
const Lt = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, It = (e, n, t) => {
  let r;
  const a = Lt[e];
  return typeof a == "string" ? r = a : n === 1 ? r = a.one : r = a.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + r : r + " ago" : r;
};
function he(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const Rt = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Bt = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Ht = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, jt = {
  date: he({
    formats: Rt,
    defaultWidth: "full"
  }),
  time: he({
    formats: Bt,
    defaultWidth: "full"
  }),
  dateTime: he({
    formats: Ht,
    defaultWidth: "full"
  })
}, At = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, qt = (e, n, t, r) => At[e];
function z(e) {
  return (n, t) => {
    const r = t != null && t.context ? String(t.context) : "standalone";
    let a;
    if (r === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = t != null && t.width ? String(t.width) : i;
      a = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = t != null && t.width ? String(t.width) : e.defaultWidth;
      a = e.values[s] || e.values[i];
    }
    const o = e.argumentCallback ? e.argumentCallback(n) : n;
    return a[o];
  };
}
const Qt = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Xt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Vt = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Gt = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, $t = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, zt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ut = (e, n) => {
  const t = Number(e), r = t % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, Jt = {
  ordinalNumber: Ut,
  era: z({
    values: Qt,
    defaultWidth: "wide"
  }),
  quarter: z({
    values: Xt,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: z({
    values: Vt,
    defaultWidth: "wide"
  }),
  day: z({
    values: Gt,
    defaultWidth: "wide"
  }),
  dayPeriod: z({
    values: $t,
    defaultWidth: "wide",
    formattingValues: zt,
    defaultFormattingWidth: "wide"
  })
};
function U(e) {
  return (n, t = {}) => {
    const r = t.width, a = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = n.match(a);
    if (!o)
      return null;
    const i = o[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(s) ? Zt(s, (f) => f.test(i)) : (
      // [TODO] -- I challenge you to fix the type
      Kt(s, (f) => f.test(i))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(u) : u, c = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(c)
    ) : c;
    const l = n.slice(i.length);
    return { value: c, rest: l };
  };
}
function Kt(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function Zt(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function en(e) {
  return (n, t = {}) => {
    const r = n.match(e.matchPattern);
    if (!r) return null;
    const a = r[0], o = n.match(e.parsePattern);
    if (!o) return null;
    let i = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    i = t.valueCallback ? t.valueCallback(i) : i;
    const s = n.slice(a.length);
    return { value: i, rest: s };
  };
}
const tn = /^(\d+)(th|st|nd|rd)?/i, nn = /\d+/i, rn = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, an = {
  any: [/^b/i, /^(a|c)/i]
}, on = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, sn = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, un = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, ln = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, cn = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, dn = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, fn = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, hn = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, mn = {
  ordinalNumber: en({
    matchPattern: tn,
    parsePattern: nn,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: U({
    matchPatterns: rn,
    defaultMatchWidth: "wide",
    parsePatterns: an,
    defaultParseWidth: "any"
  }),
  quarter: U({
    matchPatterns: on,
    defaultMatchWidth: "wide",
    parsePatterns: sn,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: U({
    matchPatterns: un,
    defaultMatchWidth: "wide",
    parsePatterns: ln,
    defaultParseWidth: "any"
  }),
  day: U({
    matchPatterns: cn,
    defaultMatchWidth: "wide",
    parsePatterns: dn,
    defaultParseWidth: "any"
  }),
  dayPeriod: U({
    matchPatterns: fn,
    defaultMatchWidth: "any",
    parsePatterns: hn,
    defaultParseWidth: "any"
  })
}, ze = {
  code: "en-US",
  formatDistance: It,
  formatLong: jt,
  formatRelative: qt,
  localize: Jt,
  match: mn,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function vn(e, n) {
  const t = k(e, n == null ? void 0 : n.in);
  return T(t, Ge(t)) + 1;
}
function Ue(e, n) {
  const t = k(e, n == null ? void 0 : n.in), r = +j(t) - +St(t);
  return Math.round(r / Me) + 1;
}
function Je(e, n) {
  var l, f, h, m;
  const t = k(e, n == null ? void 0 : n.in), r = t.getFullYear(), a = Z(), o = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((f = (l = n == null ? void 0 : n.locale) == null ? void 0 : l.options) == null ? void 0 : f.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((m = (h = a.locale) == null ? void 0 : h.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, i = C((n == null ? void 0 : n.in) || e, 0);
  i.setFullYear(r + 1, 0, o), i.setHours(0, 0, 0, 0);
  const s = E(i, n), u = C((n == null ? void 0 : n.in) || e, 0);
  u.setFullYear(r, 0, o), u.setHours(0, 0, 0, 0);
  const c = E(u, n);
  return +t >= +s ? r + 1 : +t >= +c ? r : r - 1;
}
function yn(e, n) {
  var s, u, c, l;
  const t = Z(), r = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((u = (s = n == null ? void 0 : n.locale) == null ? void 0 : s.options) == null ? void 0 : u.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((l = (c = t.locale) == null ? void 0 : c.options) == null ? void 0 : l.firstWeekContainsDate) ?? 1, a = Je(e, n), o = C((n == null ? void 0 : n.in) || e, 0);
  return o.setFullYear(a, 0, r), o.setHours(0, 0, 0, 0), E(o, n);
}
function Ke(e, n) {
  const t = k(e, n == null ? void 0 : n.in), r = +E(t, n) - +yn(t, n);
  return Math.round(r / Me) + 1;
}
function M(e, n) {
  const t = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(n, "0");
  return t + r;
}
const R = {
  // Year
  y(e, n) {
    const t = e.getFullYear(), r = t > 0 ? t : 1 - t;
    return M(n === "yy" ? r % 100 : r, n.length);
  },
  // Month
  M(e, n) {
    const t = e.getMonth();
    return n === "M" ? String(t + 1) : M(t + 1, 2);
  },
  // Day of the month
  d(e, n) {
    return M(e.getDate(), n.length);
  },
  // AM or PM
  a(e, n) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, n) {
    return M(e.getHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H(e, n) {
    return M(e.getHours(), n.length);
  },
  // Minute
  m(e, n) {
    return M(e.getMinutes(), n.length);
  },
  // Second
  s(e, n) {
    return M(e.getSeconds(), n.length);
  },
  // Fraction of second
  S(e, n) {
    const t = n.length, r = e.getMilliseconds(), a = Math.trunc(
      r * Math.pow(10, t - 3)
    );
    return M(a, n.length);
  }
}, X = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Le = {
  // Era
  G: function(e, n, t) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return t.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return t.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, n, t) {
    if (n === "yo") {
      const r = e.getFullYear(), a = r > 0 ? r : 1 - r;
      return t.ordinalNumber(a, { unit: "year" });
    }
    return R.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, t, r) {
    const a = Je(e, r), o = a > 0 ? a : 1 - a;
    if (n === "YY") {
      const i = o % 100;
      return M(i, 2);
    }
    return n === "Yo" ? t.ordinalNumber(o, { unit: "year" }) : M(o, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    const t = Ve(e);
    return M(t, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    const t = e.getFullYear();
    return M(t, n.length);
  },
  // Quarter
  Q: function(e, n, t) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return M(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, t) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return M(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, t) {
    const r = e.getMonth();
    switch (n) {
      case "M":
      case "MM":
        return R.M(e, n);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return t.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, n, t) {
    const r = e.getMonth();
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return M(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return t.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, n, t, r) {
    const a = Ke(e, r);
    return n === "wo" ? t.ordinalNumber(a, { unit: "week" }) : M(a, n.length);
  },
  // ISO week of year
  I: function(e, n, t) {
    const r = Ue(e);
    return n === "Io" ? t.ordinalNumber(r, { unit: "week" }) : M(r, n.length);
  },
  // Day of the month
  d: function(e, n, t) {
    return n === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : R.d(e, n);
  },
  // Day of year
  D: function(e, n, t) {
    const r = vn(e);
    return n === "Do" ? t.ordinalNumber(r, { unit: "dayOfYear" }) : M(r, n.length);
  },
  // Day of week
  E: function(e, n, t) {
    const r = e.getDay();
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, t, r) {
    const a = e.getDay(), o = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return M(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(o, { unit: "day" });
      case "eee":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, t, r) {
    const a = e.getDay(), o = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return M(o, n.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return t.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(a, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return t.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, t) {
    const r = e.getDay(), a = r === 0 ? 7 : r;
    switch (n) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return M(a, n.length);
      // 2nd
      case "io":
        return t.ordinalNumber(a, { unit: "day" });
      // Tue
      case "iii":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, t) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, t) {
    const r = e.getHours();
    let a;
    switch (r === 12 ? a = X.noon : r === 0 ? a = X.midnight : a = r / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, t) {
    const r = e.getHours();
    let a;
    switch (r >= 17 ? a = X.evening : r >= 12 ? a = X.afternoon : r >= 4 ? a = X.morning : a = X.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, t) {
    if (n === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), t.ordinalNumber(r, { unit: "hour" });
    }
    return R.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, t) {
    return n === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : R.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, t) {
    const r = e.getHours() % 12;
    return n === "Ko" ? t.ordinalNumber(r, { unit: "hour" }) : M(r, n.length);
  },
  // Hour [1-24]
  k: function(e, n, t) {
    let r = e.getHours();
    return r === 0 && (r = 24), n === "ko" ? t.ordinalNumber(r, { unit: "hour" }) : M(r, n.length);
  },
  // Minute
  m: function(e, n, t) {
    return n === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : R.m(e, n);
  },
  // Second
  s: function(e, n, t) {
    return n === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : R.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return R.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, t) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (n) {
      // Hours and optional minutes
      case "X":
        return Re(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return H(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return H(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, t) {
    const r = e.getTimezoneOffset();
    switch (n) {
      // Hours and optional minutes
      case "x":
        return Re(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return H(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return H(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, t) {
    const r = e.getTimezoneOffset();
    switch (n) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ie(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + H(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, t) {
    const r = e.getTimezoneOffset();
    switch (n) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ie(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + H(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, t) {
    const r = Math.trunc(+e / 1e3);
    return M(r, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, t) {
    return M(+e, n.length);
  }
};
function Ie(e, n = "") {
  const t = e > 0 ? "-" : "+", r = Math.abs(e), a = Math.trunc(r / 60), o = r % 60;
  return o === 0 ? t + String(a) : t + String(a) + n + M(o, 2);
}
function Re(e, n) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + M(Math.abs(e) / 60, 2) : H(e, n);
}
function H(e, n = "") {
  const t = e > 0 ? "-" : "+", r = Math.abs(e), a = M(Math.trunc(r / 60), 2), o = M(r % 60, 2);
  return t + a + n + o;
}
const Be = (e, n) => {
  switch (e) {
    case "P":
      return n.date({ width: "short" });
    case "PP":
      return n.date({ width: "medium" });
    case "PPP":
      return n.date({ width: "long" });
    case "PPPP":
    default:
      return n.date({ width: "full" });
  }
}, Ze = (e, n) => {
  switch (e) {
    case "p":
      return n.time({ width: "short" });
    case "pp":
      return n.time({ width: "medium" });
    case "ppp":
      return n.time({ width: "long" });
    case "pppp":
    default:
      return n.time({ width: "full" });
  }
}, bn = (e, n) => {
  const t = e.match(/(P+)(p+)?/) || [], r = t[1], a = t[2];
  if (!a)
    return Be(e, n);
  let o;
  switch (r) {
    case "P":
      o = n.dateTime({ width: "short" });
      break;
    case "PP":
      o = n.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = n.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = n.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", Be(r, n)).replace("{{time}}", Ze(a, n));
}, gn = {
  p: Ze,
  P: bn
}, wn = /^D+$/, _n = /^Y+$/, Dn = ["D", "DD", "YY", "YYYY"];
function Mn(e) {
  return wn.test(e);
}
function kn(e) {
  return _n.test(e);
}
function Nn(e, n, t) {
  const r = xn(e, n, t);
  if (console.warn(r), Dn.includes(e)) throw new RangeError(r);
}
function xn(e, n, t) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${n}\`) for formatting ${r} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Pn = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Cn = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, On = /^'([^]*?)'?$/, pn = /''/g, Sn = /[a-zA-Z]/;
function Q(e, n, t) {
  var l, f, h, m, g, D, w, x;
  const r = Z(), a = (t == null ? void 0 : t.locale) ?? r.locale ?? ze, o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : f.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((m = (h = r.locale) == null ? void 0 : h.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, i = (t == null ? void 0 : t.weekStartsOn) ?? ((D = (g = t == null ? void 0 : t.locale) == null ? void 0 : g.options) == null ? void 0 : D.weekStartsOn) ?? r.weekStartsOn ?? ((x = (w = r.locale) == null ? void 0 : w.options) == null ? void 0 : x.weekStartsOn) ?? 0, s = k(e, t == null ? void 0 : t.in);
  if (!Ft(s))
    throw new RangeError("Invalid time value");
  let u = n.match(Cn).map((_) => {
    const P = _[0];
    if (P === "p" || P === "P") {
      const B = gn[P];
      return B(_, a.formatLong);
    }
    return _;
  }).join("").match(Pn).map((_) => {
    if (_ === "''")
      return { isToken: !1, value: "'" };
    const P = _[0];
    if (P === "'")
      return { isToken: !1, value: Wn(_) };
    if (Le[P])
      return { isToken: !0, value: _ };
    if (P.match(Sn))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + P + "`"
      );
    return { isToken: !1, value: _ };
  });
  a.localize.preprocessor && (u = a.localize.preprocessor(s, u));
  const c = {
    firstWeekContainsDate: o,
    weekStartsOn: i,
    locale: a
  };
  return u.map((_) => {
    if (!_.isToken) return _.value;
    const P = _.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && kn(P) || !(t != null && t.useAdditionalDayOfYearTokens) && Mn(P)) && Nn(P, n, String(e));
    const B = Le[P[0]];
    return B(s, P, a.localize, c);
  }).join("");
}
function Wn(e) {
  const n = e.match(On);
  return n ? n[1].replace(pn, "'") : e;
}
function Yn(e, n) {
  const t = k(e, n == null ? void 0 : n.in), r = t.getFullYear(), a = t.getMonth(), o = C(t, 0);
  return o.setFullYear(r, a + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function Tn(e) {
  return Math.trunc(+k(e) / 1e3);
}
function Fn(e, n) {
  const t = k(e, n == null ? void 0 : n.in), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(0, 0, 0, 0), k(t, n == null ? void 0 : n.in);
}
function En(e, n) {
  const t = k(e, n == null ? void 0 : n.in);
  return Et(
    Fn(t, n),
    S(t, n),
    n
  ) + 1;
}
function De(e, n) {
  return +k(e) > +k(n);
}
function et(e, n) {
  return +k(e) < +k(n);
}
function Pe(e, n, t) {
  const [r, a] = G(
    t == null ? void 0 : t.in,
    e,
    n
  );
  return r.getFullYear() === a.getFullYear() && r.getMonth() === a.getMonth();
}
function Ln(e, n, t) {
  const [r, a] = G(
    t == null ? void 0 : t.in,
    e,
    n
  );
  return r.getFullYear() === a.getFullYear();
}
function me(e, n, t) {
  return O(e, -n, t);
}
function ve(e, n, t) {
  const r = k(e, t == null ? void 0 : t.in), a = r.getFullYear(), o = r.getDate(), i = C(e, 0);
  i.setFullYear(a, n, 15), i.setHours(0, 0, 0, 0);
  const s = Yn(i);
  return r.setMonth(n, Math.min(o, s)), r;
}
function He(e, n, t) {
  const r = k(e, t == null ? void 0 : t.in);
  return isNaN(+r) ? C(e, NaN) : (r.setFullYear(n), r);
}
var y = function() {
  return y = Object.assign || function(n) {
    for (var t, r = 1, a = arguments.length; r < a; r++) {
      t = arguments[r];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
    }
    return n;
  }, y.apply(this, arguments);
};
function In(e, n) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && n.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      n.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (t[r[a]] = e[r[a]]);
  return t;
}
function tt(e, n, t) {
  for (var r = 0, a = n.length, o; r < a; r++)
    (o || !(r in n)) && (o || (o = Array.prototype.slice.call(n, 0, r)), o[r] = n[r]);
  return e.concat(o || Array.prototype.slice.call(n));
}
function ee(e) {
  return e.mode === "multiple";
}
function te(e) {
  return e.mode === "range";
}
function se(e) {
  return e.mode === "single";
}
var Rn = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function Bn(e, n) {
  return Q(e, "LLLL y", n);
}
function Hn(e, n) {
  return Q(e, "d", n);
}
function jn(e, n) {
  return Q(e, "LLLL", n);
}
function An(e) {
  return "".concat(e);
}
function qn(e, n) {
  return Q(e, "cccccc", n);
}
function Qn(e, n) {
  return Q(e, "yyyy", n);
}
var Xn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: Bn,
  formatDay: Hn,
  formatMonthCaption: jn,
  formatWeekNumber: An,
  formatWeekdayName: qn,
  formatYearCaption: Qn
}), Vn = function(e, n, t) {
  return Q(e, "do MMMM (EEEE)", t);
}, Gn = function() {
  return "Month: ";
}, $n = function() {
  return "Go to next month";
}, zn = function() {
  return "Go to previous month";
}, Un = function(e, n) {
  return Q(e, "cccc", n);
}, Jn = function(e) {
  return "Week n. ".concat(e);
}, Kn = function() {
  return "Year: ";
}, Zn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: Vn,
  labelMonthDropdown: Gn,
  labelNext: $n,
  labelPrevious: zn,
  labelWeekNumber: Jn,
  labelWeekday: Un,
  labelYearDropdown: Kn
});
function er() {
  var e = "buttons", n = Rn, t = ze, r = {}, a = {}, o = 1, i = {}, s = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: n,
    formatters: Xn,
    labels: Zn,
    locale: t,
    modifiersClassNames: r,
    modifiers: a,
    numberOfMonths: o,
    styles: i,
    today: s,
    mode: "default"
  };
}
function tr(e) {
  var n = e.fromYear, t = e.toYear, r = e.fromMonth, a = e.toMonth, o = e.fromDate, i = e.toDate;
  return r ? o = S(r) : n && (o = new Date(n, 0, 1)), a ? i = Ne(a) : t && (i = new Date(t, 11, 31)), {
    fromDate: o ? V(o) : void 0,
    toDate: i ? V(i) : void 0
  };
}
var nt = A(void 0);
function nr(e) {
  var n, t = e.initialProps, r = er(), a = tr(t), o = a.fromDate, i = a.toDate, s = (n = t.captionLayout) !== null && n !== void 0 ? n : r.captionLayout;
  s !== "buttons" && (!o || !i) && (s = "buttons");
  var u;
  (se(t) || ee(t) || te(t)) && (u = t.onSelect);
  var c = y(y(y({}, r), t), { captionLayout: s, classNames: y(y({}, r.classNames), t.classNames), components: y({}, t.components), formatters: y(y({}, r.formatters), t.formatters), fromDate: o, labels: y(y({}, r.labels), t.labels), mode: t.mode || r.mode, modifiers: y(y({}, r.modifiers), t.modifiers), modifiersClassNames: y(y({}, r.modifiersClassNames), t.modifiersClassNames), onSelect: u, styles: y(y({}, r.styles), t.styles), toDate: i });
  return d(nt.Provider, { value: c, children: e.children });
}
function N() {
  var e = q(nt);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function rt(e) {
  var n = N(), t = n.locale, r = n.classNames, a = n.styles, o = n.formatters.formatCaption;
  return d("div", { className: r.caption_label, style: a.caption_label, "aria-live": "polite", role: "presentation", id: e.id, children: o(e.displayMonth, { locale: t }) });
}
function rr(e) {
  return d("svg", y({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e, { children: d("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function at(e) {
  var n, t, r = e.onChange, a = e.value, o = e.children, i = e.caption, s = e.className, u = e.style, c = N(), l = (t = (n = c.components) === null || n === void 0 ? void 0 : n.IconDropdown) !== null && t !== void 0 ? t : rr;
  return F("div", { className: s, style: u, children: [d("span", { className: c.classNames.vhidden, children: e["aria-label"] }), d("select", { name: e.name, "aria-label": e["aria-label"], className: c.classNames.dropdown, style: c.styles.dropdown, value: a, onChange: r, children: o }), F("div", { className: c.classNames.caption_label, style: c.styles.caption_label, "aria-hidden": "true", children: [i, d(l, { className: c.classNames.dropdown_icon, style: c.styles.dropdown_icon })] })] });
}
function ar(e) {
  var n, t = N(), r = t.fromDate, a = t.toDate, o = t.styles, i = t.locale, s = t.formatters.formatMonthCaption, u = t.classNames, c = t.components, l = t.labels.labelMonthDropdown;
  if (!r)
    return d(I, {});
  if (!a)
    return d(I, {});
  var f = [];
  if (Ln(r, a))
    for (var h = S(r), m = r.getMonth(); m <= a.getMonth(); m++)
      f.push(ve(h, m));
  else
    for (var h = S(/* @__PURE__ */ new Date()), m = 0; m <= 11; m++)
      f.push(ve(h, m));
  var g = function(w) {
    var x = Number(w.target.value), _ = ve(S(e.displayMonth), x);
    e.onChange(_);
  }, D = (n = c == null ? void 0 : c.Dropdown) !== null && n !== void 0 ? n : at;
  return d(D, { name: "months", "aria-label": l(), className: u.dropdown_month, style: o.dropdown_month, onChange: g, value: e.displayMonth.getMonth(), caption: s(e.displayMonth, { locale: i }), children: f.map(function(w) {
    return d("option", { value: w.getMonth(), children: s(w, { locale: i }) }, w.getMonth());
  }) });
}
function or(e) {
  var n, t = e.displayMonth, r = N(), a = r.fromDate, o = r.toDate, i = r.locale, s = r.styles, u = r.classNames, c = r.components, l = r.formatters.formatYearCaption, f = r.labels.labelYearDropdown, h = [];
  if (!a)
    return d(I, {});
  if (!o)
    return d(I, {});
  for (var m = a.getFullYear(), g = o.getFullYear(), D = m; D <= g; D++)
    h.push(He(Ge(/* @__PURE__ */ new Date()), D));
  var w = function(_) {
    var P = He(S(t), Number(_.target.value));
    e.onChange(P);
  }, x = (n = c == null ? void 0 : c.Dropdown) !== null && n !== void 0 ? n : at;
  return d(x, { name: "years", "aria-label": f(), className: u.dropdown_year, style: s.dropdown_year, onChange: w, value: t.getFullYear(), caption: l(t, { locale: i }), children: h.map(function(_) {
    return d("option", { value: _.getFullYear(), children: l(_, { locale: i }) }, _.getFullYear());
  }) });
}
function ir(e, n) {
  var t = J(e), r = t[0], a = t[1], o = n === void 0 ? r : n;
  return [o, a];
}
function sr(e) {
  var n = e.month, t = e.defaultMonth, r = e.today, a = n || t || r || /* @__PURE__ */ new Date(), o = e.toDate, i = e.fromDate, s = e.numberOfMonths, u = s === void 0 ? 1 : s;
  if (o && K(o, a) < 0) {
    var c = -1 * (u - 1);
    a = W(o, c);
  }
  return i && K(a, i) < 0 && (a = i), S(a);
}
function ur() {
  var e = N(), n = sr(e), t = ir(n, e.month), r = t[0], a = t[1], o = function(i) {
    var s;
    if (!e.disableNavigation) {
      var u = S(i);
      a(u), (s = e.onMonthChange) === null || s === void 0 || s.call(e, u);
    }
  };
  return [r, o];
}
function lr(e, n) {
  for (var t = n.reverseMonths, r = n.numberOfMonths, a = S(e), o = S(W(a, r)), i = K(o, a), s = [], u = 0; u < i; u++) {
    var c = W(a, u);
    s.push(c);
  }
  return t && (s = s.reverse()), s;
}
function cr(e, n) {
  if (!n.disableNavigation) {
    var t = n.toDate, r = n.pagedNavigation, a = n.numberOfMonths, o = a === void 0 ? 1 : a, i = r ? o : 1, s = S(e);
    if (!t)
      return W(s, i);
    var u = K(t, e);
    if (!(u < o))
      return W(s, i);
  }
}
function dr(e, n) {
  if (!n.disableNavigation) {
    var t = n.fromDate, r = n.pagedNavigation, a = n.numberOfMonths, o = a === void 0 ? 1 : a, i = r ? o : 1, s = S(e);
    if (!t)
      return W(s, -i);
    var u = K(s, t);
    if (!(u <= 0))
      return W(s, -i);
  }
}
var ot = A(void 0);
function fr(e) {
  var n = N(), t = ur(), r = t[0], a = t[1], o = lr(r, n), i = cr(r, n), s = dr(r, n), u = function(f) {
    return o.some(function(h) {
      return Pe(f, h);
    });
  }, c = function(f, h) {
    u(f) || (h && et(f, h) ? a(W(f, 1 + n.numberOfMonths * -1)) : a(f));
  }, l = {
    currentMonth: r,
    displayMonths: o,
    goToMonth: a,
    goToDate: c,
    previousMonth: s,
    nextMonth: i,
    isDateDisplayed: u
  };
  return d(ot.Provider, { value: l, children: e.children });
}
function ne() {
  var e = q(ot);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function je(e) {
  var n, t = N(), r = t.classNames, a = t.styles, o = t.components, i = ne().goToMonth, s = function(l) {
    i(W(l, e.displayIndex ? -e.displayIndex : 0));
  }, u = (n = o == null ? void 0 : o.CaptionLabel) !== null && n !== void 0 ? n : rt, c = d(u, { id: e.id, displayMonth: e.displayMonth });
  return F("div", { className: r.caption_dropdowns, style: a.caption_dropdowns, children: [d("div", { className: r.vhidden, children: c }), d(ar, { onChange: s, displayMonth: e.displayMonth }), d(or, { onChange: s, displayMonth: e.displayMonth })] });
}
function hr(e) {
  return d("svg", y({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: d("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function mr(e) {
  return d("svg", y({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: d("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var oe = Dt(function(e, n) {
  var t = N(), r = t.classNames, a = t.styles, o = [r.button_reset, r.button];
  e.className && o.push(e.className);
  var i = o.join(" "), s = y(y({}, a.button_reset), a.button);
  return e.style && Object.assign(s, e.style), d("button", y({}, e, { ref: n, type: "button", className: i, style: s }));
});
function vr(e) {
  var n, t, r = N(), a = r.dir, o = r.locale, i = r.classNames, s = r.styles, u = r.labels, c = u.labelPrevious, l = u.labelNext, f = r.components;
  if (!e.nextMonth && !e.previousMonth)
    return d(I, {});
  var h = c(e.previousMonth, { locale: o }), m = [
    i.nav_button,
    i.nav_button_previous
  ].join(" "), g = l(e.nextMonth, { locale: o }), D = [
    i.nav_button,
    i.nav_button_next
  ].join(" "), w = (n = f == null ? void 0 : f.IconRight) !== null && n !== void 0 ? n : mr, x = (t = f == null ? void 0 : f.IconLeft) !== null && t !== void 0 ? t : hr;
  return F("div", { className: i.nav, style: s.nav, children: [!e.hidePrevious && d(oe, { name: "previous-month", "aria-label": h, className: m, style: s.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick, children: a === "rtl" ? d(w, { className: i.nav_icon, style: s.nav_icon }) : d(x, { className: i.nav_icon, style: s.nav_icon }) }), !e.hideNext && d(oe, { name: "next-month", "aria-label": g, className: D, style: s.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick, children: a === "rtl" ? d(x, { className: i.nav_icon, style: s.nav_icon }) : d(w, { className: i.nav_icon, style: s.nav_icon }) })] });
}
function Ae(e) {
  var n = N().numberOfMonths, t = ne(), r = t.previousMonth, a = t.nextMonth, o = t.goToMonth, i = t.displayMonths, s = i.findIndex(function(g) {
    return Pe(e.displayMonth, g);
  }), u = s === 0, c = s === i.length - 1, l = n > 1 && (u || !c), f = n > 1 && (c || !u), h = function() {
    r && o(r);
  }, m = function() {
    a && o(a);
  };
  return d(vr, { displayMonth: e.displayMonth, hideNext: l, hidePrevious: f, nextMonth: a, previousMonth: r, onPreviousClick: h, onNextClick: m });
}
function yr(e) {
  var n, t = N(), r = t.classNames, a = t.disableNavigation, o = t.styles, i = t.captionLayout, s = t.components, u = (n = s == null ? void 0 : s.CaptionLabel) !== null && n !== void 0 ? n : rt, c;
  return a ? c = d(u, { id: e.id, displayMonth: e.displayMonth }) : i === "dropdown" ? c = d(je, { displayMonth: e.displayMonth, id: e.id }) : i === "dropdown-buttons" ? c = F(I, { children: [d(je, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id }), d(Ae, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id })] }) : c = F(I, { children: [d(u, { id: e.id, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), d(Ae, { displayMonth: e.displayMonth, id: e.id })] }), d("div", { className: r.caption, style: o.caption, children: c });
}
function br(e) {
  var n = N(), t = n.footer, r = n.styles, a = n.classNames.tfoot;
  return t ? d("tfoot", { className: a, style: r.tfoot, children: d("tr", { children: d("td", { colSpan: 8, children: t }) }) }) : d(I, {});
}
function gr(e, n, t) {
  for (var r = t ? j(/* @__PURE__ */ new Date()) : E(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: n }), a = [], o = 0; o < 7; o++) {
    var i = O(r, o);
    a.push(i);
  }
  return a;
}
function wr() {
  var e = N(), n = e.classNames, t = e.styles, r = e.showWeekNumber, a = e.locale, o = e.weekStartsOn, i = e.ISOWeek, s = e.formatters.formatWeekdayName, u = e.labels.labelWeekday, c = gr(a, o, i);
  return F("tr", { style: t.head_row, className: n.head_row, children: [r && d("td", { style: t.head_cell, className: n.head_cell }), c.map(function(l, f) {
    return d("th", { scope: "col", className: n.head_cell, style: t.head_cell, "aria-label": u(l, { locale: a }), children: s(l, { locale: a }) }, f);
  })] });
}
function _r() {
  var e, n = N(), t = n.classNames, r = n.styles, a = n.components, o = (e = a == null ? void 0 : a.HeadRow) !== null && e !== void 0 ? e : wr;
  return d("thead", { style: r.head, className: t.head, children: d(o, {}) });
}
function Dr(e) {
  var n = N(), t = n.locale, r = n.formatters.formatDay;
  return d(I, { children: r(e.date, { locale: t }) });
}
var Ce = A(void 0);
function Mr(e) {
  if (!ee(e.initialProps)) {
    var n = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return d(Ce.Provider, { value: n, children: e.children });
  }
  return d(kr, { initialProps: e.initialProps, children: e.children });
}
function kr(e) {
  var n = e.initialProps, t = e.children, r = n.selected, a = n.min, o = n.max, i = function(c, l, f) {
    var h, m;
    (h = n.onDayClick) === null || h === void 0 || h.call(n, c, l, f);
    var g = !!(l.selected && a && (r == null ? void 0 : r.length) === a);
    if (!g) {
      var D = !!(!l.selected && o && (r == null ? void 0 : r.length) === o);
      if (!D) {
        var w = r ? tt([], r) : [];
        if (l.selected) {
          var x = w.findIndex(function(_) {
            return p(c, _);
          });
          w.splice(x, 1);
        } else
          w.push(c);
        (m = n.onSelect) === null || m === void 0 || m.call(n, w, c, l, f);
      }
    }
  }, s = {
    disabled: []
  };
  r && s.disabled.push(function(c) {
    var l = o && r.length > o - 1, f = r.some(function(h) {
      return p(h, c);
    });
    return !!(l && !f);
  });
  var u = {
    selected: r,
    onDayClick: i,
    modifiers: s
  };
  return d(Ce.Provider, { value: u, children: t });
}
function Oe() {
  var e = q(Ce);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function Nr(e, n) {
  var t = n || {}, r = t.from, a = t.to;
  return r && a ? p(a, e) && p(r, e) ? void 0 : p(a, e) ? { from: a, to: void 0 } : p(r, e) ? void 0 : De(r, e) ? { from: e, to: a } : { from: r, to: e } : a ? De(e, a) ? { from: a, to: e } : { from: e, to: a } : r ? et(e, r) ? { from: e, to: r } : { from: r, to: e } : { from: e, to: void 0 };
}
var pe = A(void 0);
function xr(e) {
  if (!te(e.initialProps)) {
    var n = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return d(pe.Provider, { value: n, children: e.children });
  }
  return d(Pr, { initialProps: e.initialProps, children: e.children });
}
function Pr(e) {
  var n = e.initialProps, t = e.children, r = n.selected, a = r || {}, o = a.from, i = a.to, s = n.min, u = n.max, c = function(m, g, D) {
    var w, x;
    (w = n.onDayClick) === null || w === void 0 || w.call(n, m, g, D);
    var _ = Nr(m, r);
    (x = n.onSelect) === null || x === void 0 || x.call(n, _, m, g, D);
  }, l = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (o ? (l.range_start = [o], i ? (l.range_end = [i], p(o, i) || (l.range_middle = [
    {
      after: o,
      before: i
    }
  ])) : l.range_end = [o]) : i && (l.range_start = [i], l.range_end = [i]), s && (o && !i && l.disabled.push({
    after: me(o, s - 1),
    before: O(o, s - 1)
  }), o && i && l.disabled.push({
    after: o,
    before: O(o, s - 1)
  }), !o && i && l.disabled.push({
    after: me(i, s - 1),
    before: O(i, s - 1)
  })), u) {
    if (o && !i && (l.disabled.push({
      before: O(o, -u + 1)
    }), l.disabled.push({
      after: O(o, u - 1)
    })), o && i) {
      var f = T(i, o) + 1, h = u - f;
      l.disabled.push({
        before: me(o, h)
      }), l.disabled.push({
        after: O(i, h)
      });
    }
    !o && i && (l.disabled.push({
      before: O(i, -u + 1)
    }), l.disabled.push({
      after: O(i, u - 1)
    }));
  }
  return d(pe.Provider, { value: { selected: r, onDayClick: c, modifiers: l }, children: t });
}
function Se() {
  var e = q(pe);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function re(e) {
  return Array.isArray(e) ? tt([], e) : e !== void 0 ? [e] : [];
}
function Cr(e) {
  var n = {};
  return Object.entries(e).forEach(function(t) {
    var r = t[0], a = t[1];
    n[r] = re(a);
  }), n;
}
var Y;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(Y || (Y = {}));
var Or = Y.Selected, L = Y.Disabled, pr = Y.Hidden, Sr = Y.Today, ye = Y.RangeEnd, be = Y.RangeMiddle, ge = Y.RangeStart, Wr = Y.Outside;
function Yr(e, n, t) {
  var r, a = (r = {}, r[Or] = re(e.selected), r[L] = re(e.disabled), r[pr] = re(e.hidden), r[Sr] = [e.today], r[ye] = [], r[be] = [], r[ge] = [], r[Wr] = [], r);
  return e.fromDate && a[L].push({ before: e.fromDate }), e.toDate && a[L].push({ after: e.toDate }), ee(e) ? a[L] = a[L].concat(n.modifiers[L]) : te(e) && (a[L] = a[L].concat(t.modifiers[L]), a[ge] = t.modifiers[ge], a[be] = t.modifiers[be], a[ye] = t.modifiers[ye]), a;
}
var it = A(void 0);
function Tr(e) {
  var n = N(), t = Oe(), r = Se(), a = Yr(n, t, r), o = Cr(n.modifiers), i = y(y({}, a), o);
  return d(it.Provider, { value: i, children: e.children });
}
function st() {
  var e = q(it);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function Fr(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function Er(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function Lr(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function Ir(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function Rr(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function Br(e, n) {
  var t, r = n.from, a = n.to;
  if (r && a) {
    var o = T(a, r) < 0;
    o && (t = [a, r], r = t[0], a = t[1]);
    var i = T(e, r) >= 0 && T(a, e) >= 0;
    return i;
  }
  return a ? p(a, e) : r ? p(r, e) : !1;
}
function Hr(e) {
  return ke(e);
}
function jr(e) {
  return Array.isArray(e) && e.every(ke);
}
function Ar(e, n) {
  return n.some(function(t) {
    if (typeof t == "boolean")
      return t;
    if (Hr(t))
      return p(e, t);
    if (jr(t))
      return t.includes(e);
    if (Er(t))
      return Br(e, t);
    if (Rr(t))
      return t.dayOfWeek.includes(e.getDay());
    if (Fr(t)) {
      var r = T(t.before, e), a = T(t.after, e), o = r > 0, i = a < 0, s = De(t.before, t.after);
      return s ? i && o : o || i;
    }
    return Lr(t) ? T(e, t.after) > 0 : Ir(t) ? T(t.before, e) > 0 : typeof t == "function" ? t(e) : !1;
  });
}
function We(e, n, t) {
  var r = Object.keys(n).reduce(function(o, i) {
    var s = n[i];
    return Ar(e, s) && o.push(i), o;
  }, []), a = {};
  return r.forEach(function(o) {
    return a[o] = !0;
  }), t && !Pe(e, t) && (a.outside = !0), a;
}
function qr(e, n) {
  for (var t = S(e[0]), r = Ne(e[e.length - 1]), a, o, i = t; i <= r; ) {
    var s = We(i, n), u = !s.disabled && !s.hidden;
    if (!u) {
      i = O(i, 1);
      continue;
    }
    if (s.selected)
      return i;
    s.today && !o && (o = i), a || (a = i), i = O(i, 1);
  }
  return o || a;
}
var Qr = 365;
function ut(e, n) {
  var t = n.moveBy, r = n.direction, a = n.context, o = n.modifiers, i = n.retry, s = i === void 0 ? { count: 0, lastFocused: e } : i, u = a.weekStartsOn, c = a.fromDate, l = a.toDate, f = a.locale, h = {
    day: O,
    week: _e,
    month: W,
    year: Wt,
    startOfWeek: function(w) {
      return a.ISOWeek ? j(w) : E(w, { locale: f, weekStartsOn: u });
    },
    endOfWeek: function(w) {
      return a.ISOWeek ? $e(w) : xe(w, { locale: f, weekStartsOn: u });
    }
  }, m = h[t](e, r === "after" ? 1 : -1);
  r === "before" && c ? m = Yt([c, m]) : r === "after" && l && (m = Tt([l, m]));
  var g = !0;
  if (o) {
    var D = We(m, o);
    g = !D.disabled && !D.hidden;
  }
  return g ? m : s.count > Qr ? s.lastFocused : ut(m, {
    moveBy: t,
    direction: r,
    context: a,
    modifiers: o,
    retry: y(y({}, s), { count: s.count + 1 })
  });
}
var lt = A(void 0);
function Xr(e) {
  var n = ne(), t = st(), r = J(), a = r[0], o = r[1], i = J(), s = i[0], u = i[1], c = qr(n.displayMonths, t), l = a ?? (s && n.isDateDisplayed(s)) ? s : c, f = function() {
    u(a), o(void 0);
  }, h = function(w) {
    o(w);
  }, m = N(), g = function(w, x) {
    if (a) {
      var _ = ut(a, {
        moveBy: w,
        direction: x,
        context: m,
        modifiers: t
      });
      p(a, _) || (n.goToDate(_, a), h(_));
    }
  }, D = {
    focusedDay: a,
    focusTarget: l,
    blur: f,
    focus: h,
    focusDayAfter: function() {
      return g("day", "after");
    },
    focusDayBefore: function() {
      return g("day", "before");
    },
    focusWeekAfter: function() {
      return g("week", "after");
    },
    focusWeekBefore: function() {
      return g("week", "before");
    },
    focusMonthBefore: function() {
      return g("month", "before");
    },
    focusMonthAfter: function() {
      return g("month", "after");
    },
    focusYearBefore: function() {
      return g("year", "before");
    },
    focusYearAfter: function() {
      return g("year", "after");
    },
    focusStartOfWeek: function() {
      return g("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return g("endOfWeek", "after");
    }
  };
  return d(lt.Provider, { value: D, children: e.children });
}
function Ye() {
  var e = q(lt);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function Vr(e, n) {
  var t = st(), r = We(e, t, n);
  return r;
}
var Te = A(void 0);
function Gr(e) {
  if (!se(e.initialProps)) {
    var n = {
      selected: void 0
    };
    return d(Te.Provider, { value: n, children: e.children });
  }
  return d($r, { initialProps: e.initialProps, children: e.children });
}
function $r(e) {
  var n = e.initialProps, t = e.children, r = function(o, i, s) {
    var u, c, l;
    if ((u = n.onDayClick) === null || u === void 0 || u.call(n, o, i, s), i.selected && !n.required) {
      (c = n.onSelect) === null || c === void 0 || c.call(n, void 0, o, i, s);
      return;
    }
    (l = n.onSelect) === null || l === void 0 || l.call(n, o, o, i, s);
  }, a = {
    selected: n.selected,
    onDayClick: r
  };
  return d(Te.Provider, { value: a, children: t });
}
function ct() {
  var e = q(Te);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function zr(e, n) {
  var t = N(), r = ct(), a = Oe(), o = Se(), i = Ye(), s = i.focusDayAfter, u = i.focusDayBefore, c = i.focusWeekAfter, l = i.focusWeekBefore, f = i.blur, h = i.focus, m = i.focusMonthBefore, g = i.focusMonthAfter, D = i.focusYearBefore, w = i.focusYearAfter, x = i.focusStartOfWeek, _ = i.focusEndOfWeek, P = function(b) {
    var v, le, ce, de;
    se(t) ? (v = r.onDayClick) === null || v === void 0 || v.call(r, e, n, b) : ee(t) ? (le = a.onDayClick) === null || le === void 0 || le.call(a, e, n, b) : te(t) ? (ce = o.onDayClick) === null || ce === void 0 || ce.call(o, e, n, b) : (de = t.onDayClick) === null || de === void 0 || de.call(t, e, n, b);
  }, B = function(b) {
    var v;
    h(e), (v = t.onDayFocus) === null || v === void 0 || v.call(t, e, n, b);
  }, ue = function(b) {
    var v;
    f(), (v = t.onDayBlur) === null || v === void 0 || v.call(t, e, n, b);
  }, $ = function(b) {
    var v;
    (v = t.onDayMouseEnter) === null || v === void 0 || v.call(t, e, n, b);
  }, dt = function(b) {
    var v;
    (v = t.onDayMouseLeave) === null || v === void 0 || v.call(t, e, n, b);
  }, ft = function(b) {
    var v;
    (v = t.onDayPointerEnter) === null || v === void 0 || v.call(t, e, n, b);
  }, ht = function(b) {
    var v;
    (v = t.onDayPointerLeave) === null || v === void 0 || v.call(t, e, n, b);
  }, mt = function(b) {
    var v;
    (v = t.onDayTouchCancel) === null || v === void 0 || v.call(t, e, n, b);
  }, vt = function(b) {
    var v;
    (v = t.onDayTouchEnd) === null || v === void 0 || v.call(t, e, n, b);
  }, yt = function(b) {
    var v;
    (v = t.onDayTouchMove) === null || v === void 0 || v.call(t, e, n, b);
  }, bt = function(b) {
    var v;
    (v = t.onDayTouchStart) === null || v === void 0 || v.call(t, e, n, b);
  }, gt = function(b) {
    var v;
    (v = t.onDayKeyUp) === null || v === void 0 || v.call(t, e, n, b);
  }, wt = function(b) {
    var v;
    switch (b.key) {
      case "ArrowLeft":
        b.preventDefault(), b.stopPropagation(), t.dir === "rtl" ? s() : u();
        break;
      case "ArrowRight":
        b.preventDefault(), b.stopPropagation(), t.dir === "rtl" ? u() : s();
        break;
      case "ArrowDown":
        b.preventDefault(), b.stopPropagation(), c();
        break;
      case "ArrowUp":
        b.preventDefault(), b.stopPropagation(), l();
        break;
      case "PageUp":
        b.preventDefault(), b.stopPropagation(), b.shiftKey ? D() : m();
        break;
      case "PageDown":
        b.preventDefault(), b.stopPropagation(), b.shiftKey ? w() : g();
        break;
      case "Home":
        b.preventDefault(), b.stopPropagation(), x();
        break;
      case "End":
        b.preventDefault(), b.stopPropagation(), _();
        break;
    }
    (v = t.onDayKeyDown) === null || v === void 0 || v.call(t, e, n, b);
  }, _t = {
    onClick: P,
    onFocus: B,
    onBlur: ue,
    onKeyDown: wt,
    onKeyUp: gt,
    onMouseEnter: $,
    onMouseLeave: dt,
    onPointerEnter: ft,
    onPointerLeave: ht,
    onTouchCancel: mt,
    onTouchEnd: vt,
    onTouchMove: yt,
    onTouchStart: bt
  };
  return _t;
}
function Ur() {
  var e = N(), n = ct(), t = Oe(), r = Se(), a = se(e) ? n.selected : ee(e) ? t.selected : te(e) ? r.selected : void 0;
  return a;
}
function Jr(e) {
  return Object.values(Y).includes(e);
}
function Kr(e, n) {
  var t = [e.classNames.day];
  return Object.keys(n).forEach(function(r) {
    var a = e.modifiersClassNames[r];
    if (a)
      t.push(a);
    else if (Jr(r)) {
      var o = e.classNames["day_".concat(r)];
      o && t.push(o);
    }
  }), t;
}
function Zr(e, n) {
  var t = y({}, e.styles.day);
  return Object.keys(n).forEach(function(r) {
    var a;
    t = y(y({}, t), (a = e.modifiersStyles) === null || a === void 0 ? void 0 : a[r]);
  }), t;
}
function ea(e, n, t) {
  var r, a, o, i = N(), s = Ye(), u = Vr(e, n), c = zr(e, u), l = Ur(), f = !!(i.onDayClick || i.mode !== "default");
  ie(function() {
    var $;
    u.outside || s.focusedDay && f && p(s.focusedDay, e) && (($ = t.current) === null || $ === void 0 || $.focus());
  }, [
    s.focusedDay,
    e,
    t,
    f,
    u.outside
  ]);
  var h = Kr(i, u).join(" "), m = Zr(i, u), g = !!(u.outside && !i.showOutsideDays || u.hidden), D = (o = (a = i.components) === null || a === void 0 ? void 0 : a.DayContent) !== null && o !== void 0 ? o : Dr, w = d(D, { date: e, displayMonth: n, activeModifiers: u }), x = {
    style: m,
    className: h,
    children: w,
    role: "gridcell"
  }, _ = s.focusTarget && p(s.focusTarget, e) && !u.outside, P = s.focusedDay && p(s.focusedDay, e), B = y(y(y({}, x), (r = { disabled: u.disabled, role: "gridcell" }, r["aria-selected"] = u.selected, r.tabIndex = P || _ ? 0 : -1, r)), c), ue = {
    isButton: f,
    isHidden: g,
    activeModifiers: u,
    selectedDays: l,
    buttonProps: B,
    divProps: x
  };
  return ue;
}
function ta(e) {
  var n = kt(null), t = ea(e.date, e.displayMonth, n);
  return t.isHidden ? d("div", { role: "gridcell" }) : t.isButton ? d(oe, y({ name: "day", ref: n }, t.buttonProps)) : d("div", y({}, t.divProps));
}
function na(e) {
  var n = e.number, t = e.dates, r = N(), a = r.onWeekNumberClick, o = r.styles, i = r.classNames, s = r.locale, u = r.labels.labelWeekNumber, c = r.formatters.formatWeekNumber, l = c(Number(n), { locale: s });
  if (!a)
    return d("span", { className: i.weeknumber, style: o.weeknumber, children: l });
  var f = u(Number(n), { locale: s }), h = function(m) {
    a(n, t, m);
  };
  return d(oe, { name: "week-number", "aria-label": f, className: i.weeknumber, style: o.weeknumber, onClick: h, children: l });
}
function ra(e) {
  var n, t, r = N(), a = r.styles, o = r.classNames, i = r.showWeekNumber, s = r.components, u = (n = s == null ? void 0 : s.Day) !== null && n !== void 0 ? n : ta, c = (t = s == null ? void 0 : s.WeekNumber) !== null && t !== void 0 ? t : na, l;
  return i && (l = d("td", { className: o.cell, style: a.cell, children: d(c, { number: e.weekNumber, dates: e.dates }) })), F("tr", { className: o.row, style: a.row, children: [l, e.dates.map(function(f) {
    return d("td", { className: o.cell, style: a.cell, role: "presentation", children: d(u, { displayMonth: e.displayMonth, date: f }) }, Tn(f));
  })] });
}
function qe(e, n, t) {
  for (var r = t != null && t.ISOWeek ? $e(n) : xe(n, t), a = t != null && t.ISOWeek ? j(e) : E(e, t), o = T(r, a), i = [], s = 0; s <= o; s++)
    i.push(O(a, s));
  var u = i.reduce(function(c, l) {
    var f = t != null && t.ISOWeek ? Ue(l) : Ke(l, t), h = c.find(function(m) {
      return m.weekNumber === f;
    });
    return h ? (h.dates.push(l), c) : (c.push({
      weekNumber: f,
      dates: [l]
    }), c);
  }, []);
  return u;
}
function aa(e, n) {
  var t = qe(S(e), Ne(e), n);
  if (n != null && n.useFixedWeeks) {
    var r = En(e, n);
    if (r < 6) {
      var a = t[t.length - 1], o = a.dates[a.dates.length - 1], i = _e(o, 6 - r), s = qe(_e(o, 1), i, n);
      t.push.apply(t, s);
    }
  }
  return t;
}
function oa(e) {
  var n, t, r, a = N(), o = a.locale, i = a.classNames, s = a.styles, u = a.hideHead, c = a.fixedWeeks, l = a.components, f = a.weekStartsOn, h = a.firstWeekContainsDate, m = a.ISOWeek, g = aa(e.displayMonth, {
    useFixedWeeks: !!c,
    ISOWeek: m,
    locale: o,
    weekStartsOn: f,
    firstWeekContainsDate: h
  }), D = (n = l == null ? void 0 : l.Head) !== null && n !== void 0 ? n : _r, w = (t = l == null ? void 0 : l.Row) !== null && t !== void 0 ? t : ra, x = (r = l == null ? void 0 : l.Footer) !== null && r !== void 0 ? r : br;
  return F("table", { id: e.id, className: i.table, style: s.table, role: "grid", "aria-labelledby": e["aria-labelledby"], children: [!u && d(D, {}), d("tbody", { className: i.tbody, style: s.tbody, children: g.map(function(_) {
    return d(w, { displayMonth: e.displayMonth, dates: _.dates, weekNumber: _.weekNumber }, _.weekNumber);
  }) }), d(x, { displayMonth: e.displayMonth })] });
}
function ia() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var sa = ia() ? Mt : ie, we = !1, ua = 0;
function Qe() {
  return "react-day-picker-".concat(++ua);
}
function la(e) {
  var n, t = e ?? (we ? Qe() : null), r = J(t), a = r[0], o = r[1];
  return sa(function() {
    a === null && o(Qe());
  }, []), ie(function() {
    we === !1 && (we = !0);
  }, []), (n = e ?? a) !== null && n !== void 0 ? n : void 0;
}
function ca(e) {
  var n, t, r = N(), a = r.dir, o = r.classNames, i = r.styles, s = r.components, u = ne().displayMonths, c = la(r.id ? "".concat(r.id, "-").concat(e.displayIndex) : void 0), l = r.id ? "".concat(r.id, "-grid-").concat(e.displayIndex) : void 0, f = [o.month], h = i.month, m = e.displayIndex === 0, g = e.displayIndex === u.length - 1, D = !m && !g;
  a === "rtl" && (n = [m, g], g = n[0], m = n[1]), m && (f.push(o.caption_start), h = y(y({}, h), i.caption_start)), g && (f.push(o.caption_end), h = y(y({}, h), i.caption_end)), D && (f.push(o.caption_between), h = y(y({}, h), i.caption_between));
  var w = (t = s == null ? void 0 : s.Caption) !== null && t !== void 0 ? t : yr;
  return F("div", { className: f.join(" "), style: h, children: [d(w, { id: c, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), d(oa, { id: l, "aria-labelledby": c, displayMonth: e.displayMonth })] }, e.displayIndex);
}
function da(e) {
  var n = N(), t = n.classNames, r = n.styles;
  return d("div", { className: t.months, style: r.months, children: e.children });
}
function fa(e) {
  var n, t, r = e.initialProps, a = N(), o = Ye(), i = ne(), s = J(!1), u = s[0], c = s[1];
  ie(function() {
    a.initialFocus && o.focusTarget && (u || (o.focus(o.focusTarget), c(!0)));
  }, [
    a.initialFocus,
    u,
    o.focus,
    o.focusTarget,
    o
  ]);
  var l = [a.classNames.root, a.className];
  a.numberOfMonths > 1 && l.push(a.classNames.multiple_months), a.showWeekNumber && l.push(a.classNames.with_weeknumber);
  var f = y(y({}, a.styles.root), a.style), h = Object.keys(r).filter(function(g) {
    return g.startsWith("data-");
  }).reduce(function(g, D) {
    var w;
    return y(y({}, g), (w = {}, w[D] = r[D], w));
  }, {}), m = (t = (n = r.components) === null || n === void 0 ? void 0 : n.Months) !== null && t !== void 0 ? t : da;
  return d("div", y({ className: l.join(" "), style: f, dir: a.dir, id: a.id, nonce: r.nonce, title: r.title, lang: r.lang }, h, { children: d(m, { children: i.displayMonths.map(function(g, D) {
    return d(ca, { displayIndex: D, displayMonth: g }, D);
  }) }) }));
}
function ha(e) {
  var n = e.children, t = In(e, ["children"]);
  return d(nr, { initialProps: t, children: d(fr, { children: d(Gr, { initialProps: t, children: d(Mr, { initialProps: t, children: d(xr, { initialProps: t, children: d(Tr, { children: d(Xr, { children: n }) }) }) }) }) }) });
}
function ma(e) {
  return d(ha, y({}, e, { children: d(fa, { initialProps: e }) }));
}
function va({ className: e, classNames: n, showOutsideDays: t = !0, ...r }) {
  return /* @__PURE__ */ d(
    ma,
    {
      showOutsideDays: t,
      className: fe("p-3", e),
      classNames: {
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-sm font-medium",
        nav: "space-x-1 flex items-center",
        nav_button: fe(
          Fe({ variant: "outline" }),
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"
        ),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",
        head_row: "flex",
        head_cell: "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]",
        row: "flex w-full mt-2",
        cell: "h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected])]:bg-accent [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent/50 first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
        day: fe(Fe({ variant: "ghost" }), "h-9 w-9 p-0 font-normal aria-selected:opacity-100"),
        day_range_end: "day-range-end",
        day_selected: "bg-accent text-accent-foreground hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground",
        day_today: "border border-accent bg-transparent",
        day_outside: "day-outside text-muted-foreground opacity-50 aria-selected:bg-accent/50 aria-selected:text-muted-foreground aria-selected:opacity-30",
        day_disabled: "text-muted-foreground opacity-50",
        day_range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
        day_hidden: "invisible",
        ...n
      },
      components: {
        IconLeft: () => /* @__PURE__ */ d(xt, { className: "size-4" }),
        IconRight: () => /* @__PURE__ */ d(Ct, { className: "size-4" })
      },
      ...r
    }
  );
}
va.displayName = "Calendar";
export {
  va as C,
  Q as f
};
//# sourceMappingURL=calendar-C-HUqdjN.js.map
